



































import { defineComponent } from '@nuxtjs/composition-api';

import BaseButton from '../BaseButton/BaseButton.vue';
import BaseChevron from '../BaseChevron/BaseChevron.vue';

export default defineComponent({
  name: 'BaseAccordionItem',
  components: {
    BaseChevron,
    BaseButton,
  },
  props: {
    header: {
      type: String,
      default: '',
    },
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
    chevronPositions: {
      type: Object,
      default: () => ({
        closed: 'down',
        open: 'right',
      }),
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    amIOpen(): boolean {
      return this.isOpen || this.alwaysOpen;
    },
  },
  methods: {
    accordionClick() {
      // todo - this component method fires on parent, consider refactor.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.$parent.$emit('toggle', (this as any)._uid);
    },
  },
});
